import React from 'react';
import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData } from '../../api';
import { useAuth } from '../../session/InternalAuthProvider';
import { FilterMenu } from '../../common/filter/FilterMenu';
import { WorkshopsFilterSection } from '../../common/filter/WorkshopsFilterSection';
import { CheckboxGroupSection } from '../../common/filter/CheckboxGroupSection';
import { ALL_ORDER_STATUSES, useOrdersFilter } from './OrdersFilterContext';
import { useOrdersFilterSummary } from './useOrdersFilterSummary';

type Props = {
  hideStatuses?: boolean;
};

export const OrdersFilter = ({ hideStatuses }: Props) => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const summary = useOrdersFilterSummary(hideStatuses);
  const { selectedOrderPageIds, setSelectedOrderPageIds, statuses, setStatuses, isFilterActive, resetFilter } =
    useOrdersFilter();

  return (
    <FilterMenu
      name="Orders"
      isActive={isFilterActive}
      summaryLabel={summary.primary}
      secondaryLabel={summary.secondary}
      onReset={resetFilter}>
      <List disablePadding>
        <WorkshopsFilterSection
          account={account}
          selectedIds={selectedOrderPageIds}
          onChange={setSelectedOrderPageIds}
        />

        {!hideStatuses && (
          <CheckboxGroupSection
            title={t('orders.filter.statuses')}
            items={ALL_ORDER_STATUSES}
            itemLabel={(status) => t(`order_status.${status}`)}
            selected={statuses}
            onChange={setStatuses}
            withDivider={false}
          />
        )}
      </List>
    </FilterMenu>
  );
};
